import { ReactNode } from "react";
import { useParams } from "react-router";
import { DeliveryTemplatesListTable } from "./_components/delivery-templates-list-table";
import { DeliveryTemplateModal } from "./_components/delivery-template-modal";

export function DeliveryTemplates(): ReactNode {
  const { customerId } = useParams();
  return (
    <div className="flex flex-col space-y-2">
      {customerId && <DeliveryTemplateModal customerId={customerId} />}
      <DeliveryTemplatesListTable customerId={customerId as string} />
    </div>
  );
}
